import React from 'react';
import "./supply-encoding-landing.css";
import "./style.css";
import {LogoHp} from "@veneer/core";


const MaintenancePage = () => {
    return(
        <div className="container">
            <div className="row p-20-header">
                <div className="col-md-12">
                    <table>
                        <tr>
                            <td>
                                <LogoHp appearance="multicolor" size={40}/>
                            </td>
                            <td>
                                <p className="pmargin">
                                    <h4>HP Supply Encoding Service</h4>

                                </p>
                            </td>
                        </tr>
                    </table>
                    <p className="maintenanceErrorMsg"> We are currently offline for maintenance.<br></br>
                        Sorry for the inconvenience. Please check back soon.</p>
                </div>
            </div>
        </div>
    )
}

export default MaintenancePage;